import { useState, useEffect } from 'react';

export const useResponsiveMargin = () => {
  const [rootMargin, setRootMargin] = useState(() => {
    // Initial calculation based on current window size
    return window.innerWidth <= 768 ? '800px' : '1500px';
  });

  useEffect(() => {
    const updateMargin = () => {
      const isMobile = window.innerWidth <= 768;
      const newMargin = isMobile ? '800px' : '1500px';
      setRootMargin(newMargin);
    };

    // Listen for resize events
    window.addEventListener('resize', updateMargin);
    
    // Initial call
    updateMargin();

    return () => {
      window.removeEventListener('resize', updateMargin);
    };
  }, []);

  return rootMargin;
};